import React,{Component} from 'react';

class MyClub extends React.Component{
    render(){
    return(
        <div class="font_meie_script" style={{textAlign:'center',color:'white'}}>
            <h2>Maths Club SASTRA <br/> also known as MCS,MCS is a student club founded on Feb 14 2014.<br/> Our club is full of Mathematics entusiasts <br/> who strive to achive perfection in all the challenges they pick.<br/>
                We at MCS conducted many events like <br/> ANUBHUVA,KLF Lecture,CONNECTICA,MATHRUNNERS,MATHPIRATES and <br/> we have also launched a MCS annual fest known as INFINITE .<br/> We have team APTICON which 
                which made Aptitude easy for everyone<br/> and also released an MCS Magazine GANITHAMITHRA 1.0 and 2.0
            </h2>
        </div>
    );
}}

export default MyClub;